<template>
	<div class="auth-page">
		<div class="auth-page__left">
			<auth-screen-hello />
		</div>
		<div class="auth-page__right">
			<div class="auth-wrap">
        <template v-if="false">
          <div class="auth-wrap__logo">
            <img src="@/assets/img/sparks-logo.png" alt="sparks-logo">
          </div>
        </template>
				<div class="auth-wrap__body">
					<div class="auth-wrap__title h4">Welcome 👋🏻</div>
					<div class="auth-wrap__subtitle">Enter the information below to use this platform.</div>
					<div class="auth-wrap__form">
						<auth-form />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  import AuthScreenHello from '@/components/AuthScreen/components/AuthScreenHello.vue'
  import AuthForm from '@/components/AuthScreen/components/AuthForm.vue'

  export default {
    name: 'AuthScreen',

    components: {
      AuthScreenHello,
      AuthForm,
    }
  }
</script>

<style lang="less">
	@import "@/assets/style/variables.less";

	.auth-page {
		height: 100%;

		@media @desktop {
			display: flex;
		}

		&__left {
			display: none;

			@media @desktop {
				display: block;
				flex: 1 1 57%;
			}
		}

		&__right {
			min-height: 100%;
			display: flex;
			align-items: center;

			@media @desktop {
				flex: 1 1 43%;
			}
		}
	}

	.auth-wrap {
		max-width: 620px;
		padding: 24px;
		display: flex;
		flex-direction: column;
		margin: 0 auto;

		@media @desktop {
			padding: 80px;
		}

		&__logo {
			flex: 0 1 auto;
			margin-bottom: 80px;

			& img {
				margin: 0 auto;
				display: block;
				width: 100%;
				max-width: 344px;
			}
		}

		&__body {
			flex: 1 1 auto;
			display: flex;
			flex-direction: column;
			justify-content: center;

		}

		&__form {

		}

		&__title {
			text-align: center;
			margin-bottom: 12px;
		}

		&__subtitle {
			font-size: 16px;
			text-align: center;
			margin-bottom: 32px;
		}
	}
</style>